module.exports = __webpack_public_path__ + "static/media/mac_acc.ee2c7055.svg";